import { render, staticRenderFns } from "./GroupSessionNotesAddEditModal.vue?vue&type=template&id=1310ac98&"
import script from "./GroupSessionNotesAddEditModal.vue?vue&type=script&lang=js&"
export * from "./GroupSessionNotesAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports